// TypeScript enums: https://www.typescriptlang.org/docs/handbook/enums.html
export enum YinzCamDataFormat {
  JSON,
  XML,
  TEXT,
  URLENCODED
}
